var _jsxFileName = "/codebuild/output/src1571341075/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/InitializationErrorPage/index.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { LoadingModal, Modal } from '@adc/parallax-component-library';
import { APP_RETURN_TIMEOUT, ApiStatus } from 'Constants';
import { MainContainer, Providers } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
const InitializationErrorPage = ({
  errorStatus
}) => {
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const error = useMemo(() => {
    switch (errorStatus) {
      case ApiStatus.INTERNAL_SERVER_ERROR:
        return {
          title: 'Global.modals.internetConnectionError.title',
          message: 'Global.modals.internetConnectionError.body'
        };
      case ApiStatus.UNAUTHORIZED:
        return {
          title: 'Global.modals.featureNotAvailable.title',
          message: 'Global.modals.featureNotAvailable.body'
        };
      default:
        return {
          title: 'Global.modals.internetConnectionError.title',
          message: 'Global.modals.errorCommunicatingServer.body'
        };
    }
  }, [errorStatus]);
  const onClose = useCallback(() => {
    setIsOpen(false);
    setLoading(true);
    notifyApp('adc-webview:navigate-back-app');

    // Give the app some time to redirect the user back.
    setTimeout(() => {
      setLoading(false);
    }, APP_RETURN_TIMEOUT);
  }, []);
  return /*#__PURE__*/React.createElement(Providers, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    header: i18n.t(error.title),
    details: i18n.t(error.message),
    primaryAction: {
      label: i18n.t('Global.microcopy.common.okCap'),
      onPress: onClose
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 9
    }
  })));
};
export { InitializationErrorPage };